import React from "react";
import { Container, Box } from '@mui/material';
import Header from '../../layout/Header';
import MainContent from '../../components/MainContent';
import Footer from '../../layout/Footer';

export default function LandingPage({connectToWalmart, disconnect, logout}) {
    return (
        <Box sx={{ flexGrow: 1, padding: '0px 0px 20px 0px' }}>
            <Header logout={logout}/>
            <Container
                maxWidth="lg"
                component="main"
                sx={{ display: 'flex', flexDirection: 'column', my: 3, gap: 4 }}
            >
                <MainContent connectToWalmart={connectToWalmart}/>
            </Container>
            <Footer disconnect={disconnect} />
        </Box>
    );
}